<template>
  <v-card class="h-full">
    <ODialogBar title="Contrato" no-close>
      <v-spacer />
      <v-btn icon @click="() => $refs.dialog.open(row.id)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </ODialogBar>
    <v-card-text>
      <OCapCont label="Número do Contrato" class="mb-4">
        {{ row.contractCode || '-' }}
      </OCapCont>

      <OCapCont label="Data de Início do Contrato" class="mb-4">
        {{ row.contractStartDate | moment('DD/MMM/YYYY') }}
      </OCapCont>

      <OCapCont label="Data da Primeira Instalação (medição 0)" class="mb-4">
        {{ row.measureStartDate | moment('DD/MMM/YYYY') }}
      </OCapCont>

      <OCapCont label="Duração do Contrato" class="mb-4">
        {{ row.contractLengthM || '-' }} meses
      </OCapCont>

      <OCapCont label="Método de Pagamento" class="mb-4">
        {{ row.paymentMethod || '-' }}
      </OCapCont>
    </v-card-text>

    <OSimpleEditDialog
      ref="dialog"
      title="Editar Contrato"
      :fetchData="fetchData"
      :doSave="doSave"
      @reload="$emit('reload')"
      strings="contrato;o"
    >
      <template v-slot="{ row }">
        <v-form
          ref="theForm"
          class="d-flex flex-row flex-wrap pa-3 children-pa-3"
        >
          <OTextField
            class="w-1/2"
            label="Número do Contrato"
            v-model="row.contractCode"
          />

          <ODateInput
            class="w-1/2"
            label="Data de Início do Contrato"
            v-model="row.contractStartDate"
          />

          <ODateInput
            class="w-1/2"
            label="Data da Primeira Instalação"
            v-model="row.measureStartDate"
          />

          <OTextField
            class="w-1/2"
            label="Duração do Contrato (meses)"
            v-model="row.contractLengthM"
          />

          <OSelect
            class="w-2/3"
            label="Método de Pagamento"
            v-model="row.paymentMethod"
            :items="allPaymentMethods"
          />
        </v-form>
      </template>
    </OSimpleEditDialog>
  </v-card>
</template>

<script>
import OSimpleEditDialog from 'oderon-vue/cpts/dialogs/OSimpleEditDialog.vue'
import { CostCenter } from '@/models'
import ODateInput from 'oderon-vue/cpts/ODateInput.vue'

export default {
  components: { OSimpleEditDialog, ODateInput },
  props: {
    row: { required: true }
  },
  data() {
    return {
      allPaymentMethods: [
        'Dinheiro',
        'Blto Email',
        'Blto Correio',
        'Transf.',
        'C. Debito',
        'C. Credito'
      ]
    }
  },
  methods: {
    async fetchData(id) {
      return await CostCenter.findById(id)
    },
    async doSave(row) {
      return await CostCenter.save(row)
    }
  }
}
</script>

<style></style>
